import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { NodegroupsDetailTabs, NodegroupsActions } from "@/resources-def/nodegroups-comp";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const RESOURCE = 'nodegroups';

export const NodegroupPage = () => {
  const { t } = useTranslation();
  
  const columns = [
    { title: "Name", dataIndex: "id", key: "id" },
    { title: t("instances.fields.status"), dataIndex: "status", render:(value) => <InstanceStatus status={value} /> },
    { title: "EKS", dataIndex: "eks", key: "eks" },
    { title: "Region", dataIndex: "region", key: "region" },
    { title: "AZ", dataIndex: "zone", key: "zone", render: (text, record) => record.zone.join(", ")},
    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Tenant", dataIndex: "tenant", key: "tenant"},
    { title: "Instance", dataIndex: "instance", key: "instance"},
    { title: "Auto scaled", dataIndex: "autoscaled", key: "autoscaled", render: (value) => ( value === 'true' && <CheckCircleOutlined />)},
    { title: "InstanceTypes", dataIndex: "instanceTypes", key: "instanceTypes"},
  ];
  return (
    <ResourceListLayout
      title={"Node Groups"}
      resource={RESOURCE}
      actions={NodegroupsActions}
      columns={columns}
      details={NodegroupsDetailTabs}
    >
    </ResourceListLayout>
  );
};